import React, { useState } from "react";
import { Button, Input, Popover } from "antd";
import { useTranslation } from "react-i18next";
import { SFPopoverProps } from "../../models/ui-models/SFPopoverProps";
import { toast } from "react-toastify";

const SFPopover = (props: SFPopoverProps) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const handleConfirm = () => {
        if (inputValue != null && inputValue != "") {
            setVisible(false);
            props.onConfirm && props.onConfirm(inputValue);
            setInputValue("");
        }
        else {
            toast.error("common.giveANameToFilter")
        }
    };

    const handleCancel = () => {
        setInputValue("");
        setVisible(false);
    };

    const popoverContent = (
        <div style={{ width: 200 }}>
            <Input
                placeholder="Enter value"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
            />
            <div style={{ marginTop: 8, textAlign: "right" }}>
                <Button size="small" onClick={handleCancel} style={{ marginRight: 8 }}>
                    {t("common.cancel")}
                </Button>
                <Button type="primary" size="small" onClick={handleConfirm}>
                    {t("monitor.save")}
                </Button>
            </div>
        </div>
    );

    return (
        <Popover
            content={popoverContent}
            title={t("monitor.nameOfFilter")}
            trigger="click"
            open={visible}
            onOpenChange={(newVisible) => setVisible(newVisible)}
        >
            <Button type="primary">{t("monitor.save")}</Button>
        </Popover>
    );
};

export default SFPopover;
